import React, { useRef, useEffect } from 'react';
import { isMessageFromTargetIFrame } from '@libs/shared';
import { FullScreenDialog } from '../../../components';

interface ModalProps {
    title: string;
    url: string;
    onClose: () => void;
    onMessage: (message: unknown) => void;
}

/**
 * 模态框
 *
 * @param props
 * @returns
 */
const Modal: React.FC<ModalProps> = (props) => {
    const { title, url, onClose, onMessage } = props;
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const iframeMessageHandler = function (event: MessageEvent) {
            // 来源校验，保证只会接收当前弹窗内嵌的 iframe 消息
            if (isMessageFromTargetIFrame(event, iframeRef.current?.contentWindow)) {
                // 将消息发送给 Worker
                onMessage(event.data?.pluginMessage);
            }
        };
        window.addEventListener('message', iframeMessageHandler);
        return () => {
            window.removeEventListener('message', iframeMessageHandler);
        };
    }, []);

    return (
        <FullScreenDialog
            visible
            title={title || ' '}
            width={1000}
            height={640}
            text4Ok={null}
            text4Cancel={null}
            separator={{ footer: false }}
            contentPadding={false}
            onCancel={() => onClose()}
        >
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, top: '56px' }}>
                <iframe
                    ref={iframeRef}
                    src={url}
                    width="100%"
                    height="100%"
                    allow="autoplay;camera;geolocation;microphone"
                    style={{ position: 'absolute', border: 'none' }}
                />
            </div>
        </FullScreenDialog>
    );
};

export default Modal;
